<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    :title="`电梯信息(${getDetailParams.statisticsDate})`"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="1100px"
  >
    <div class="dialog__container">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
      type="index"
      label="序号"
      width="50">
    </el-table-column>
        <el-table-column prop="propertyUnitName" show-overflow-tooltip label="使用单位" width="250">
        </el-table-column>
        <el-table-column prop="recentMaintainDate" label="最近维保" width="110"> </el-table-column>
        <el-table-column prop="maintainPerson" label="维保人员" width="120"> </el-table-column>
        <el-table-column prop="liftLocation" label="电梯位置" width="180"> </el-table-column>
        <el-table-column prop="projectName" label="项目名称" width="180">
        </el-table-column>
        
        <el-table-column prop="useCertificateNumber" label="使用编号" width="180"> </el-table-column>
        
        <el-table-column prop="maintainPeriod" label="维保间隔" width="100"> </el-table-column>
        <el-table-column prop="projectName" label="项目名称" width="180">
        </el-table-column>
        <el-table-column prop=" "> </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getLiftDetail } from "@/api/UserConsole";
export default {
  data() {
    return {
      form: {
        contactsPhone: "",
        contactsName: "",
        creditCode: "",
        unitName: "",
      },
      tableData: [
        
      ],
    };
  },
  props: {
    getDetailParams: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.getLiftDetail();
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$emit("cancel");
    },
    async getLiftDetail() {
      const res = await getLiftDetail(this.getDetailParams)
      if (res.code === 200) {
        this.tableData = res.data.list
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/UserConsole/components/LiftDetail.vue